import { useEffect, useRef, useState } from "react";
import { BiLogOut } from "react-icons/bi";
import { GrGraphQl } from "react-icons/gr";
import { HiMenu, HiOutlineOfficeBuilding } from "react-icons/hi";
import { IoMdArrowDropright } from "react-icons/io";
import {
  TbArrowBarToLeftDashed,
  TbArrowBarToRight,
  TbFence,
  TbScale,
} from "react-icons/tb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoImg from "../assets/logo-white.png";
import { useAuth } from "../contexts/AuthContext";
import "./BarraLateral.css";

// Importando ícones
import { BiSolidReport } from "react-icons/bi";
import { BsBank2, BsRobot } from "react-icons/bs";
import {
  FaBalanceScaleLeft,
  FaBoxes,
  FaChartLine,
  FaClipboardList,
  FaCog,
  FaDatabase,
  FaFileAlt,
  FaHandSparkles,
  FaTachometerAlt,
} from "react-icons/fa";
import {
  GiBarn,
  GiCow,
  GiFarmer,
  GiFarmTractor,
  GiField,
  GiHoneycomb,
  GiNewBorn,
  GiPlantRoots,
  GiSkullCrossedBones,
  GiWeight,
  GiWheat,
} from "react-icons/gi";
import { IoCubeOutline, IoPricetags } from "react-icons/io5";
import { LuHandCoins } from "react-icons/lu";
import {
  MdAgriculture,
  MdCategory,
  MdCreditCard,
  MdEventNote,
  MdLocationOn,
  MdMonetizationOn,
  MdOutlinePayments,
  MdPayments,
  MdHistory,
  MdPeople,
  MdReceipt,
  MdScience,
  MdSettings,
  MdSyncProblem,
} from "react-icons/md";
import {
  PiBoxArrowUpFill,
  PiFarmFill,
  PiGraphDuotone,
  PiSprayBottleFill,
} from "react-icons/pi";
import { SlGraph } from "react-icons/sl";

const BarraLateral = ({ onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { temPermissao, fazenda, cargo, logout } = useAuth();
  const [isMinimized, setIsMinimized] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [openGroup, setOpenGroup] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [popupMenu, setPopupMenu] = useState(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsMinimized(false);
        setIsMobileOpen(false);
      }
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Fecha popup ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setPopupMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const toggleMenu = (title) => {
    setOpenMenu(openMenu === title ? null : title);
  };

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileOpen(!isMobileOpen);
    } else {
      const next = !isMinimized;
      setIsMinimized(next);
      setOpenMenu(null);
      setOpenGroup(null);
      setPopupMenu(null);
      if (onToggle) onToggle(next);
    }
  };

  const getSectionIcon = (section) => {
    const icons = {
      Dashboard: <FaTachometerAlt size={20} />,
      Cadastros: <FaDatabase size={20} />,
      Atividades: <FaClipboardList size={20} />,
      Financeiro: <FaChartLine size={20} />,
      Estoque: <FaBoxes size={20} />,
      Relatórios: <FaFileAlt size={20} />,
      Configurações: <FaCog size={20} />,
    };
    return icons[section] || <FaDatabase size={20} />;
  };

  const getItemIcon = (itemName) => {
    const icons = {
      Animais: <GiCow size={18} />,
      "Categorias de Produtos": <MdCategory size={18} />,
      Culturas: <MdAgriculture size={18} />,
      "Análise de Solo": <MdScience size={18} />,
      Fazendas: <PiFarmFill size={18} />,
      Funcionários: <GiFarmer size={18} />,
      "Locais de Estoque": <MdLocationOn size={18} />,
      Lotes: <GiBarn size={18} />,
      Máquinas: <GiFarmTractor size={18} />,
      "Tipos de Máquinas": <MdCategory size={18} />,
      "Fabricantes de Máquinas": <IoPricetags size={18} />,
      Pastos: <TbFence size={18} />,
      Plantios: <GiPlantRoots size={18} />,
      Safras: <GiWheat size={18} />,
      Subcategorias: <IoPricetags size={18} />,
      Talhões: <GiHoneycomb size={18} />,
      "Tipos de Manejo": <FaHandSparkles size={18} />,
      "Tipos de Atividades": <PiSprayBottleFill size={18} />,
      "Unidades de Medida": <FaBalanceScaleLeft size={18} />,
      "Itens de Estoque": <IoCubeOutline size={18} />,
      "Movimentações de Estoque": <FaBoxes size={18} />,
      "Acerto de Estoque": <PiBoxArrowUpFill size={18} />,
      Colheita: <GiWheat size={18} />,
      "Eventos de Manejo": <MdEventNote size={18} />,
      Mortalidade: <GiSkullCrossedBones size={18} />,
      "Movimentações Fiscais": <MdReceipt size={18} />,
      Natalidade: <GiNewBorn size={18} />,
      Pesagem: <GiWeight size={18} />,
      "Pesagem no Brete": <TbScale size={18} />,
      "Registro de Atividades": <FaClipboardList size={18} />,
      "Rotação de Pastos": <GiField size={18} />,
      "Categoria Mestra": <PiGraphDuotone size={18} />,
      "Categoria Financeira": <SlGraph size={18} />,
      "Centro de Custos": <MdMonetizationOn size={18} />,
      Clientes: <MdPeople size={18} />,
      "Contas a Pagar": <MdPayments size={18} />,
      "Contas a Receber": <MdOutlinePayments size={18} />,
      "Contas Bancárias": <BsBank2 size={18} />,
      "Entrada de Notas": <MdReceipt size={18} />,
      "Formas de Pagamento": <LuHandCoins size={18} />,
      Fornecedores: <MdPeople size={18} />,
    };
    return icons[itemName] || <IoMdArrowDropright size={18} />;
  };

  // Filtra itens de submenu de acordo com a permissão da TELA específica
  // (não mais do módulo inteiro) — cada item carrega seu próprio `tela`.
  const filtrarItens = (items) => items.filter((item) => !item.tela || temPermissao(item.tela));

  const filtrarGrupos = (grupos) =>
    grupos
      .map((grupo) => ({ ...grupo, items: filtrarItens(grupo.items) }))
      .filter((grupo) => grupo.items.length > 0);

  const menuSections = [
    { section: "Dashboard", path: "/dashboard", items: null },
    {
      section: "Cadastros",
      items: filtrarItens([
        { icon: getItemIcon("Animais"), name: "Animais", path: "/pecuaria/animais", tela: "pecuaria.animais" },
        { icon: getItemIcon("Lotes"), name: "Lotes", path: "/pecuaria/lotes", tela: "pecuaria.lotes" },
        { icon: getItemIcon("Pastos"), name: "Pastos", path: "/pecuaria/pastos", tela: "pecuaria.pastos" },
        { icon: getItemIcon("Tipos de Manejo"), name: "Tipos de Manejo", path: "/pecuaria/tipomanejo", tela: "pecuaria.tipos_manejo" },
        { icon: getItemIcon("Culturas"), name: "Culturas", path: "/agricultura/culturas", tela: "agricultura.culturas" },
        { icon: getItemIcon("Análise de Solo"), name: "Análise de Solo", path: "/agricultura/analise-solo", tela: "agricultura.analise_solo" },
        { icon: getItemIcon("Plantios"), name: "Plantios", path: "/agricultura/plantios", tela: "agricultura.plantios" },
        { icon: getItemIcon("Safras"), name: "Safras", path: "/agricultura/safras", tela: "agricultura.safras" },
        { icon: getItemIcon("Tipos de Atividades"), name: "Tipos de Atividades", path: "/agricultura/tipoatividade", tela: "agricultura.tipos_atividade" },
        { icon: getItemIcon("Fazendas"), name: "Fazendas", path: "/fazendas/fazendas", tela: "fazendas.fazendas" },
        { icon: getItemIcon("Funcionários"), name: "Funcionários", path: "/fazendas/funcionarios", tela: "fazendas.funcionarios" },
        { icon: getItemIcon("Talhões"), name: "Talhões", path: "/fazendas/talhoes", tela: "fazendas.talhoes" },
        { icon: getItemIcon("Máquinas"), name: "Máquinas", path: "/fazendas/maquinas", tela: "fazendas.maquinas" },
        { icon: getItemIcon("Tipos de Máquinas"), name: "Tipos de Máquinas", path: "/fazendas/tipos-maquina", tela: "fazendas.tipos_maquina" },
        { icon: getItemIcon("Fabricantes de Máquinas"), name: "Fabricantes de Máquinas", path: "/fazendas/fabricantes-maquina", tela: "fazendas.fabricantes_maquina" },
        { icon: getItemIcon("Categorias de Produtos"), name: "Categorias de Produtos", path: "/almoxarifado/categorias", tela: "almoxarifado.categorias" },
        { icon: getItemIcon("Locais de Estoque"), name: "Locais de Estoque", path: "/almoxarifado/locaisestoque", tela: "almoxarifado.locais_estoque" },
        { icon: getItemIcon("Subcategorias"), name: "Subcategorias", path: "/almoxarifado/subcategorias", tela: "almoxarifado.subcategorias" },
        { icon: getItemIcon("Unidades de Medida"), name: "Unidades de Medida", path: "/almoxarifado/unidadesmedida", tela: "almoxarifado.unidades_medida" },
      ]),
    },
    {
      section: "Atividades",
      items: filtrarItens([
        { icon: getItemIcon("Colheita"), name: "Colheita", path: "/agricultura/colheita", tela: "agricultura.colheitas" },
        { icon: getItemIcon("Registro de Atividades"), name: "Registro de Atividades", path: "/agricultura/RegAtividades", tela: "agricultura.atividades" },
        { icon: getItemIcon("Eventos de Manejo"), name: "Eventos de Manejo", path: "/pecuaria/eventos_manejo", tela: "pecuaria.eventos_manejo" },
        { icon: getItemIcon("Mortalidade"), name: "Mortalidade", path: "/pecuaria/mortalidade", tela: "pecuaria.mortalidade" },
        { icon: getItemIcon("Movimentações Fiscais"), name: "Movimentações Fiscais", path: "/pecuaria/mov_fiscal", tela: "pecuaria.movimentacoes" },
        { icon: getItemIcon("Natalidade"), name: "Natalidade", path: "/pecuaria/natalidade", tela: "pecuaria.natalidade" },
        { icon: getItemIcon("Pesagem"), name: "Pesagem", path: "/pecuaria/pesagem", tela: "pecuaria.pesagens" },
        { icon: getItemIcon("Pesagem no Brete"), name: "Pesagem no Brete", path: "/pecuaria/brete", tela: "pecuaria.sessao_pesagem" },
        { icon: getItemIcon("Rotação de Pastos"), name: "Rotação de Pastos", path: "/pecuaria/rotacao_pastos", tela: "pecuaria.rotacao_pastos" },
      ]),
    },
    ...(() => {
      const items = filtrarItens([
        { icon: getItemIcon("Categoria Mestra"), name: "Categoria Mestra", path: "/financeiro/categoria-mestra", tela: "financeiro.categoria_mestra" },
        { icon: getItemIcon("Categoria Financeira"), name: "Categoria Financeira", path: "/financeiro/categoria-financeira", tela: "financeiro.categoria_financeira" },
        { icon: getItemIcon("Centro de Custos"), name: "Centro de Custos", path: "/financeiro/centro-custo", tela: "financeiro.centro_custo" },
        { icon: getItemIcon("Clientes"), name: "Clientes", path: "/financeiro/clientes", tela: "financeiro.clientes" },
        { icon: getItemIcon("Contas a Pagar"), name: "Contas a Pagar", path: "/financeiro/contas-pagar", tela: "financeiro.contas_a_pagar" },
        { icon: getItemIcon("Contas a Receber"), name: "Contas a Receber", path: "/financeiro/contas-receber", tela: "financeiro.contas_a_receber" },
        { icon: getItemIcon("Contas Bancárias"), name: "Contas Bancárias", path: "/financeiro/conta", tela: "financeiro.conta" },
        { icon: getItemIcon("Entrada de Notas"), name: "Entrada de Notas", path: "/financeiro/entrada-nota", tela: "financeiro.entrada_nota" },
        { icon: getItemIcon("Formas de Pagamento"), name: "Formas de Pagamento", path: "/financeiro/formas-pagamento", tela: "financeiro.formas_pagamento" },
        { icon: getItemIcon("Fornecedores"), name: "Fornecedores", path: "/financeiro/fornecedores", tela: "financeiro.fornecedores" },
      ]);
      return items.length > 0 ? [{ section: "Financeiro", items }] : [];
    })(),
    ...(() => {
      const items = filtrarItens([
        { icon: getItemIcon("Itens de Estoque"), name: "Itens de Estoque", path: "/almoxarifado/itensestoque", tela: "almoxarifado.itens_estoque" },
        { icon: getItemIcon("Acerto de Estoque"), name: "Acerto de Estoque", path: "/almoxarifado/acerto-estoque", tela: "almoxarifado.acerto_estoque" },
        { icon: getItemIcon("Movimentações de Estoque"), name: "Movimentações de Estoque", path: "/almoxarifado/movimentacoes", tela: "almoxarifado.movimentacoes" },
      ]);
      return items.length > 0 ? [{ section: "Estoque", items }] : [];
    })(),
    ...(() => {
      const groups = filtrarGrupos([
        {
          title: "Relatórios Gerais",
          icon: <BiSolidReport size={18} />,
          items: [
            { name: "Cadastros", path: "/relatorios/cadastros/cadastros", tela: "relatorios.cadastros" },
          ],
        },
        {
          title: "Relatórios Agrícolas",
          icon: <MdAgriculture size={18} />,
          items: [
            { name: "Aplicação de Insumos", path: "/relatorios/agricolas/aplicacao-insumos", tela: "relatorios.aplicacao_insumos" },
            { name: "Custo por Hectare", path: "/relatorios/agricolas/custo-hectare", tela: "relatorios.custo_hectare" },
            { name: "Produtividade por Talhão", path: "/relatorios/agricolas/produtividade-talhao/", tela: "relatorios.produtividade_talhao" },
            { name: "Plantio e Colheita", path: "/relatorios/agricolas/plantiocolheita", tela: "relatorios.plantio_colheita" },
          ],
        },
        {
          title: "Relatórios Pecuários",
          icon: <GiCow size={18} />,
          items: [
            { name: "Controle de Estoque de Animais", path: "/relatorios/pecuarios/controleestanim", tela: "relatorios.controle_estoque_animais" },
            { name: "Ganho de Peso", path: "/relatorios/pecuarios/ganho-peso/", tela: "relatorios.ganho_peso" },
            { name: "Sanidade Pecuária", path: "/relatorios/pecuarios/sanidade/", tela: "relatorios.sanidade_pecuaria" },
            { name: "Reprodução", path: "/relatorios/pecuarios/reproducao/", tela: "relatorios.reproducao" },
          ],
        },
        {
          title: "Relatórios Financeiros",
          icon: <MdMonetizationOn size={18} />,
          items: [
            { name: "Contas a Pagar e Receber", path: "/relatorios/financeiro/contas/", tela: "relatorios.contas_pagar_receber" },
            { name: "Custo por Atividade", path: "/relatorios/financeiro/custo-atividade/", tela: "relatorios.custo_por_atividade" },
            { name: "Atividades e Financeiro", path: "/relatorios/financeiro/atividades-financeiro/", tela: "relatorios.atividades_financeiro" },
            { name: "Rentabilidade", path: "/relatorios/financeiro/rentabilidade/", tela: "relatorios.rentabilidade" },
          ],
        },
        {
          title: "Relatórios de Almoxarifado",
          icon: <FaBoxes size={18} />,
          items: [
            { name: "Estoque Atualizado", path: "/relatorios/almoxarifado/est-atualizado/", tela: "relatorios.estoque_atualizado" },
            { name: "Movimentação de Estoque", path: "/relatorios/almoxarifado/movimentacoes/", tela: "relatorios.movimentacao_estoque" },
          ],
        },
        {
          title: "Relatórios de Gestão e Desempenho",
          icon: <GrGraphQl size={18} />,
          items: [
            { name: "Conformidade e Rastreabilidade", path: "/relatorios/conformidade/rastreabilidade/", tela: "relatorios.conformidade_rastreabilidade" },
            { name: "KPIs da Fazenda", path: "/relatorios/dashboard/kpis/", tela: "relatorios.dashboard_kpis" },
          ],
        },
      ]);
      return groups.length > 0 ? [{ section: "Relatórios", groups }] : [];
    })(),
    ...(() => {
      const items = filtrarItens([
        { icon: <MdPeople size={18} />, name: "Usuários", path: "/configuracoes/usuarios", tela: "configuracoes.usuarios" },
        { icon: <MdPeople size={18} />, name: "Perfis de Acesso", path: "/configuracoes/perfis", tela: "configuracoes.perfis" },
        { icon: <MdCreditCard size={18} />, name: "Planos de Uso", path: "/configuracoes/planos", tela: "configuracoes.planos" },
        { icon: <MdSyncProblem size={18} />, name: "Conflitos de Sincronização", path: "/configuracoes/conflitos-sincronizacao", tela: "configuracoes.conflitos_sincronizacao" },
        { icon: <MdSettings size={18} />, name: "Configurações do Sistema", path: "/configuracoes/sistema", tela: "configuracoes.sistema" },
        { icon: <HiOutlineOfficeBuilding size={18} />, name: "Dados da Empresa", path: "/configuracoes/dados-empresa", tela: "configuracoes.dados_empresa" },
        { icon: <BsRobot size={18} />, name: "Assistente de IA", path: "/configuracoes/assistente-ia", tela: "configuracoes.assistente_ia" },
      ]);
      return items.length > 0 ? [{ section: "Configurações", items }] : [];
    })(),
    ...(() => {
      const items = filtrarItens([
        { icon: <MdHistory size={18} />, name: "Consulta de Auditoria", path: "/auditoria/consulta", tela: "auditoria.consulta" },
      ]);
      return items.length > 0 ? [{ section: "Auditoria", items }] : [];
    })(),
  ];

  const isOpen = (!isMobile && !isMinimized) || (isMobile && isMobileOpen);

  // Renderiza o popup para modo minimizado
  const renderPopup = (section) => {
    if (!section) return null;
    const items = section.items || [];
    const groups = section.groups || [];

    return (
      <div className="sidebar-popup" ref={popupRef}>
        <div className="sidebar-popup-header">{section.section}</div>
        {items.map((item, idx) => (
          <Link
            key={idx}
            to={item.path}
            className="sidebar-popup-item"
            onClick={() => setPopupMenu(null)}
          >
            {item.icon}
            <span>{item.name}</span>
          </Link>
        ))}
        {groups.map((group, gIdx) => (
          <div key={gIdx}>
            <div className="sidebar-popup-group-title">
              {group.icon}
              <span>{group.title}</span>
            </div>
            {group.items.map((item, idx) => (
              <Link
                key={idx}
                to={item.path}
                className="sidebar-popup-item sidebar-popup-group-item"
                onClick={() => setPopupMenu(null)}
              >
                <span>{item.name}</span>
              </Link>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {/* Botão de menu mobile */}
      {isMobile && (
        <button className="mobile-menu-button" onClick={toggleSidebar}>
          <HiMenu size={24} />
        </button>
      )}

      {/* Overlay para mobile */}
      {isMobile && isMobileOpen && (
        <div className="mobile-overlay" onClick={toggleSidebar} />
      )}

      <aside
        className={`sidebar ${isMinimized && !isMobile ? "minimized" : ""} ${isMobile ? "mobile" : ""} ${isMobileOpen ? "open" : ""}`}
      >
        <div className="sidebar-header">
          {isOpen && (
            <img
              src={logoImg}
              alt="Logo"
              onClick={() => navigate("/dashboard")}
              className="logo-img"
            />
          )}
          <button className="toggle-btn" onClick={toggleSidebar}>
            {isOpen ? (
              <TbArrowBarToLeftDashed size={24} />
            ) : (
              <TbArrowBarToRight size={24} />
            )}
          </button>
        </div>

        <nav className="nav-menu">
          {menuSections.map((section) => {
            const hasChildren = section.items !== null || section.groups;
            const isPopupOpen = popupMenu?.section === section.section;

            return (
              <div
                key={section.section}
                className="nav-item-container"
                style={{ position: "relative" }}
              >
                {/* MODO MINIMIZADO */}
                {isMinimized && !isMobile ? (
                  <div
                    className={`nav-item minimized-icon ${isPopupOpen ? "open" : ""} ${location.pathname === section.path ? "active" : ""}`}
                    onClick={() => {
                      if (!hasChildren && section.path) {
                        navigate(section.path);
                        setPopupMenu(null);
                      } else {
                        setPopupMenu(isPopupOpen ? null : section);
                      }
                    }}
                    title={!hasChildren ? section.section : ""}
                  >
                    {getSectionIcon(section.section)}
                    {isPopupOpen && hasChildren && renderPopup(section)}
                  </div>
                ) : (
                  /* MODO EXPANDIDO */
                  <>
                    {!hasChildren ? (
                      <Link
                        to={section.path}
                        className={`nav-item ${location.pathname === section.path ? "active" : ""}`}
                        onClick={() => isMobile && toggleSidebar()}
                      >
                        {getSectionIcon(section.section)}
                        <span>{section.section}</span>
                      </Link>
                    ) : (
                      <>
                        <div
                          className={`nav-item ${openMenu === section.section ? "open" : ""}`}
                          onClick={() => toggleMenu(section.section)}
                        >
                          {getSectionIcon(section.section)}
                          <span>{section.section}</span>
                          <IoMdArrowDropright
                            size={16}
                            className={`nav-arrow ${openMenu === section.section ? "rotated" : ""}`}
                          />
                        </div>
                        <div
                          className={`submenu ${openMenu === section.section ? "open" : ""}`}
                        >
                          {section.items &&
                            section.items.map((item, idx) => (
                              <Link
                                key={idx}
                                to={item.path}
                                className={`submenu-item ${location.pathname === item.path ? "active" : ""}`}
                                onClick={() => {
                                  setOpenMenu(null);
                                  if (isMobile) toggleSidebar();
                                }}
                              >
                                {item.icon}
                                <span>{item.name}</span>
                              </Link>
                            ))}
                          {section.groups &&
                            section.groups.map((group, gIdx) => (
                              <div key={gIdx} className="submenu-group">
                                <div
                                  className={`submenu-group-title ${openGroup === group.title ? "open" : ""}`}
                                  onClick={() =>
                                    setOpenGroup(
                                      openGroup === group.title
                                        ? null
                                        : group.title,
                                    )
                                  }
                                >
                                  {group.icon}
                                  <span>{group.title}</span>
                                  <IoMdArrowDropright
                                    size={14}
                                    className={`group-arrow ${openGroup === group.title ? "rotated" : ""}`}
                                  />
                                </div>
                                <div
                                  className={`submenu-group-items ${openGroup === group.title ? "open" : ""}`}
                                >
                                  {group.items.map((item, idx) => (
                                    <Link
                                      key={idx}
                                      to={item.path}
                                      className="submenu-item group-item"
                                      onClick={() => {
                                        if (isMobile) toggleSidebar();
                                      }}
                                    >
                                      <span>{item.name}</span>
                                    </Link>
                                  ))}
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </nav>

        <div className="logout-container">
          <button onClick={handleLogout} className="logout-btn">
            {!isOpen ? <BiLogOut size={26} /> : "Sair"}
          </button>
        </div>
      </aside>
    </>
  );
};

export default BarraLateral;
